/**
 * @fileoverview QuicksearchFilters — "Filter" label + horizontal pill row
 * + trailing "More" dropdown. Foundry mapping:
 * `quicksearch-dialog__quicksearch-discover__1wavx6m`.
 */

import { Button } from "@blueprintjs/core";
import type { ReactElement, ReactNode } from "react";

interface QuicksearchFiltersProps {
  /** Stack of <QuicksearchCategoryTag /> elements. */
  children: ReactNode;
  /** Click handler for the trailing "More" caret. */
  onMore?: () => void;
  label?: ReactNode;
  className?: string;
}

export function QuicksearchFilters({
  children,
  onMore,
  label = "Filter",
  className,
}: QuicksearchFiltersProps): ReactElement {
  return (
    <div data-testid="quicksearch-filters" className={["bp-quicksearch-filters", className].filter(Boolean).join(" ")}>
      <div className="bp-quicksearch-filters-label">{label}</div>
      <div className="bp-quicksearch-filters-pills">{children}</div>
      {onMore && (
        <Button
          minimal
          rightIcon="caret-down"
          onClick={onMore}
          className="bp-quicksearch-filters-more"
        >
          More
        </Button>
      )}
    </div>
  );
}
